//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../no/Builder.js";
import "../Diagramming/Diagramming.RenderingPropertiesBuilder.js";
let d=[[[0,"EditRenderingProp",1,0],[1,"RenderingProperties",0,"Diagramming.RenderingPropertiesBuilder",0]],[[["sheetElements"],"SetSheetElements",{},1,0],[["deltaXCoordinate"],"SetDeltaXCoordinate",{},1,0],[["deltaYCoordinate"],"SetDeltaYCoordinate",{},1,0],[["hide"],"SetHide",{},1,0],[["hideLabel"],"SetHideLabel",{},1,0]],[]];
SPLM.Diagramming.BulkEditBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.BulkEditBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;